module.exports = __webpack_public_path__ + "img/python.89a1e1ee.svg";